// formati e controlli comuni a lista, dettaglio e schede dei costi di spedizione
import isocodes from '@/utils/isocodecountry.json';

let nomiPaesi = null;
try {
	nomiPaesi = new Intl.DisplayNames(['it'], { type: 'region' });
} catch (e) {
	nomiPaesi = null;
}

// nome del paese in italiano (ripiego sul nome inglese della tabella ISO)
export function nomePaese(codice) {
	if (!codice) return '';
	try {
		const nome = nomiPaesi && nomiPaesi.of(String(codice).toUpperCase());
		if (nome && nome !== codice) return nome;
	} catch (e) {
		// codice non valido per Intl
	}
	const iso = isocodes.find(c => c['alpha-2'] === codice);
	return (iso && iso.name) || codice;
}

// immagine della bandiera, '' se non c'e' (Bandiera.vue mostra allora il codice)
export function bandiera(codice) {
	if (!codice) return '';
	try {
		return require(`@/assets/images/flag/${String(codice).toUpperCase()}.svg`);
	} catch (e) {
		return '';
	}
}

const numero = v => {
	const n = Number(v);
	return v === '' || v === null || v === undefined || isNaN(n) ? null : n;
};

export function kg(v) {
	const n = numero(v);
	return n === null ? '—' : `${String(n).replace('.', ',')} kg`;
}

export function prezzo(v) {
	const n = numero(v);
	if (n === null) return '—';
	if (n === 0) return 'Gratis';
	return `€ ${n.toFixed(2).replace('.', ',')}`;
}

export function giorni(min, max) {
	const a = numero(min);
	const b = numero(max);
	if (!a && !b) return '—';
	if (a === b || !b) return `${a} ${a === 1 ? 'giorno' : 'giorni'}`;
	if (!a) return `fino a ${b} giorni`;
	return `${a}–${b} giorni`;
}

export function pesi(min, max) {
	const a = numero(min) || 0;
	const b = numero(max);
	if (b === null || b === 0) return a ? `da ${kg(a)}` : 'qualsiasi peso';
	return a ? `${String(a).replace('.', ',')} – ${kg(b)}` : `fino a ${kg(b)}`;
}

// zona della tariffa: paese, e se ristretta provincia e CAP
export function zona(item) {
	const dettagli = [item.province && `prov. ${String(item.province).toUpperCase()}`, item.cap && `CAP ${item.cap}`].filter(Boolean);
	return dettagli.length ? dettagli.join(' · ') : 'tutto il paese';
}

/*
 * Problemi di un insieme di fasce della stessa destinazione: minimo oltre il massimo,
 * sovrapposizioni e buchi fra una fascia e la successiva (due fasce che si toccano, 0–5 e 5–10, vanno bene).
 * Ritorna [{ indici: [i, j], testo }], indici riferiti all'array ricevuto.
 */
export function problemiFasce(fasce) {
	const problemi = [];
	const righe = fasce.map((f, i) => ({ i, min: numero(f.min) || 0, max: numero(f.max) || 0 }));
	righe.forEach(r => {
		if (r.max && r.min > r.max) problemi.push({ indici: [r.i], testo: `Fascia ${r.i + 1}: il peso minimo (${kg(r.min)}) supera il massimo (${kg(r.max)})` });
	});
	const ordinate = righe.filter(r => r.max && r.min <= r.max).sort((a, b) => a.min - b.min);
	for (let k = 1; k < ordinate.length; k++) {
		const prima = ordinate[k - 1];
		const dopo = ordinate[k];
		if (dopo.min < prima.max) {
			problemi.push({ indici: [prima.i, dopo.i], testo: `Le fasce ${prima.i + 1} e ${dopo.i + 1} si sovrappongono fra ${kg(dopo.min)} e ${kg(Math.min(prima.max, dopo.max))}` });
		} else if (dopo.min > prima.max) {
			problemi.push({ indici: [prima.i, dopo.i], testo: `Fra ${kg(prima.max)} e ${kg(dopo.min)} non c'è nessuna tariffa: per un pacco di quel peso questo metodo non compare` });
		}
	}
	return problemi;
}
